export default __webpack_public_path__ + "static/media/nuk-pro-back-sky.00c25602.jpg";